import React, { useState } from "react";
import { ReactComponent as ArrowUpRight } from "../../../../../assects/svg/client_details/ArrowUpRight.svg";
import Drawer from "./Drawer";
import { VitalLog } from "../../../hooks/useAllLogsData";

interface VitalsCardProps {
  vitals: VitalLog[];
  selectedDate?: string;
}

const VitalsCard: React.FC<VitalsCardProps> = ({ vitals, selectedDate }) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const isHighValue = (vital: VitalLog): boolean => {
    return false;
  };

  const displayedVitals = vitals.slice(0, 3);

  if (!vitals || vitals.length === 0) {
    return (
      <div className="bg-white rounded-md shadow-sm px-4 pt-3 pb-4 relative flex flex-col h-full">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-[12px] 3xl:text-sm font-semibold font-inter text-[#1F1F1F] uppercase">
            VITALS
          </h3>
        </div>
        <div className="flex-1 flex items-center justify-center">
          <p className="text-sm font-medium text-[#646464] font-inter">No entries yet</p>
        </div>
      </div>
    );
  }

  return (
    <>
      <div  onClick={() => setIsDrawerOpen(true)} className="bg-white rounded-md shadow-sm px-4 pt-3 pb-4 relative cursor-pointer">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-[12px] 3xl:text-sm font-semibold font-inter text-[#1F1F1F] uppercase">
            VITALS
          </h3>
          <button
           
            className="p-1 hover:bg-gray-100 rounded-lg transition-colors"
            aria-label="View all vitals"
          >
            <ArrowUpRight className="w-4 h-4 3xl:w-5 3xl:h-5 text-[#1F1F1F]" />
          </button>
        </div>

        {displayedVitals.map((vital, index) => (
          <React.Fragment key={index}>
            <div className="flex justify-between items-center">
              <span className="text-[12px] 3xl:text-sm font-medium font-inter text-[#1F1F1F]">
                {vital.name} ({vital.unit})
              </span>
              <div className="flex items-center gap-2">
                {isHighValue(vital) && (
                  <span className="text-red-500 text-sm font-inter">↑</span>
                )}
                <span className="text-[12px] 3xl:text-sm font-medium font-inter text-[#1F1F1F]">
                  {vital.vital_log_value}
                </span>
              </div>
            </div>
            {index < displayedVitals.length - 1 && (
              <div className="w-full border-t border-gray-200 my-2"></div>
            )}
          </React.Fragment>
        ))}
      </div>

      <Drawer
        isOpen={isDrawerOpen}
        onClose={() => setIsDrawerOpen(false)}
        title="Vitals"
        selectedDate={selectedDate}
      >
        <div className="space-y-3">
          {vitals.map((vital, index) => (
            <div
              key={index}
              className="flex justify-between items-center py-3 border-b border-gray-100"
            >
              <span className="text-[12px] 3xl:text-[14px] font-medium font-inter text-[#1F1F1F]">
                {vital.name} ({vital.unit})
              </span>
              <div className="flex items-center gap-2">
                {isHighValue(vital) && (
                  <span className="text-red-500 text-sm font-inter">↑</span>
                )}
                <span className="text-[12px] 3xl:text-[14px] font-medium font-inter text-[#1F1F1F]">
                  {vital.vital_log_value}
                </span>
              </div>
            </div>
          ))}
        </div>
      </Drawer>
    </>
  );
};

export default VitalsCard;